// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ type }) => {
  const professionalToken = localStorage.getItem("professionalToken");
  const clientToken = localStorage.getItem("clientToken");

  if (type === "professional" && !professionalToken) {
    return <Navigate to="/professional/login" replace />;
  }

  if (type === "client" && !clientToken) {
    return <Navigate to="/client/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
